module.exports = __webpack_public_path__ + "img/informationWelfare.998cc139.png";